'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/math-intrinsics@1.1.0/~/math-intrinsics/pow.js
// module id = 655
// module chunks = 0